/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: contents;
}

.qds-table-cell {
  box-sizing: border-box;
  color: var(--qds-theme-title);
  font: var(--qds-list-item-standard-title);
  padding-block: 0;
  padding-inline: var(--qds-list-item-standard-padding-horizontal);
  text-align: inherit;
  vertical-align: middle;
  width: inherit;
}
